import { CALL_SORTED_API } from 'gwx-voyager-components';
import Schemas from './subscriptionhistory.schema';

const fetchSubscriptionHistory = (subscriptionId) => ({
	[CALL_SORTED_API]: {
		types: [	'SUBSCRIPTIONHISTORY_REQUEST', 'SUBSCRIPTIONHISTORY_SUCCESS', 'SUBSCRIPTIONHISTORY_FAILURE'],
		endpoint: `subscriptions/${subscriptionId}/history`,
		schema: Schemas.SUBSCRIPTIONHISTORYS,
		mapActionToStateKey: 'subscriptionhistory'
	}
});

export const loadSubscriptionHistory = (subscriptionId) => (dispatch) => dispatch(
		fetchSubscriptionHistory(subscriptionId)
);